import { Box } from "@mui/material";

interface Props {
  onClick?: () => void;
  style?: any;
}
export const ISortSwapVert: React.FC<Props> = (props) => {
  return (
    <Box display="flex" {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="17"
        viewBox="0 -960 960 960"
        width="17"
        fill="currentColor"
        style={{ fontWeight: "bold" }}
      >
        <path d="M320-440v-287L217-624l-57-56 200-200 200 200-57 56-103-103v287h-80ZM600-80 400-280l57-56 103 103v-287h80v287l103-103 57 56L600-80Z" strokeWidth="10" stroke="currentColor"/>
      </svg>
    </Box>
  );
};
